"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _GatewayService = _interopRequireDefault(require("../GatewayService.js"));

var _errors = require("../errors.js");

var _log = _interopRequireDefault(require("../log.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var customContentService = new _GatewayService["default"]('custom-content-svc');
var CUSTOM_CONTENT_STATUSES = {
  UPLOAD_COMPLETE: 'upload-complete',
  IN_USE: 'in-use',
  REVIEWED: 'reviewed'
};
var CUSTOM_CONTENT_FACETS = {
  KEYWORDS: 'keywords',
  STANDARDS: 'standards'
};

var fetchCustomContent = function fetchCustomContent(key) {
  return customContentService.get("content/".concat(key));
};

var createCustomContent = function createCustomContent(body) {
  return customContentService.postWithHeaders('content', body).then(function (_ref) {
    var headers = _ref.headers;

    var key = _lodash["default"].last(headers.location.split('/'));

    return {
      key: key
    };
  });
};

var updateCustomContent = function updateCustomContent(body) {
  return customContentService.put('content', body);
};

var fetchCustomContentBySearch = function fetchCustomContentBySearch(search) {
  var itemCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var itemOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var sortKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var sortDescending = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (search === undefined) {
    return Promise.reject((0, _errors.missingParam)('search'));
  }

  var params = {
    row: itemOffset,
    num: itemCount
  };

  if (sortKey) {
    params.sort = sortKey;
  } // Service sort is ascending by default


  if (sortDescending) {
    params.dir = !sortDescending;
  }

  return customContentService.post('content-search', search, {
    params: params
  }).then(function (_ref2) {
    var results = _ref2.results;
    return results;
  });
};

var fetchCustomContentByAdvancedSearch = function fetchCustomContentByAdvancedSearch(search) {
  var itemCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var itemOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var sortKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var sortDescending = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (search === undefined) {
    return Promise.reject((0, _errors.missingParam)('search'));
  }

  search.rowCount = itemCount;
  search.startRow = itemOffset;

  if (sortKey) {
    search.sortKey = sortKey;
  } // Service sort is ascending by default


  if (sortDescending) {
    search.sortDirAsc = !sortDescending;
  }

  return customContentService.post('content-search/advanced', search);
}; // Fetch a single custom content item.


var fetchCustomContentItemBySearch = function fetchCustomContentItemBySearch(search) {
  return fetchCustomContentBySearch(search, 1).then(function (results) {
    return results[0];
  });
};

var getCustomContentForLesson = function getCustomContentForLesson(unitKey, chapterKey, lessonKey, maxCustomLessonsReturned, sortKey) {
  if (_lodash["default"].isEmpty(unitKey) && _lodash["default"].isEmpty(chapterKey) && _lodash["default"].isEmpty(lessonKey)) {
    _log["default"].error('Custom content not found because unitKey, chapterKey, and lessonKey were all not specified');

    return Promise.reject((0, _errors.missingParam)('unitKey, chapterKey, lessonKey'));
  }

  if (_lodash["default"].isEmpty(maxCustomLessonsReturned)) {
    _log["default"].error('Custom content not found because maxCustomLessonsReturned was not specified');

    return Promise.reject((0, _errors.missingParam)('maxCustomLessonsReturned'));
  }

  if (_lodash["default"].isEmpty(sortKey)) {
    _log["default"].error('Custom content not found because sortKey was not specified');

    return Promise.reject((0, _errors.missingParam)('sortKey'));
  }

  var body = {
    levelReplacementFlags: []
  };

  if (!_lodash["default"].isEmpty(unitKey)) {
    body.levelReplacementFlags.push({
      level: "UNIT:".concat(unitKey)
    });
  }

  if (!_lodash["default"].isEmpty(chapterKey)) {
    body.levelReplacementFlags.push({
      level: "CHAPTER:".concat(chapterKey)
    });
  }

  if (!_lodash["default"].isEmpty(lessonKey)) {
    body.levelReplacementFlags.push({
      level: "LESSON:".concat(lessonKey)
    });
  }

  return customContentService.post('content-search', body, {
    params: {
      row: 0,
      num: maxCustomLessonsReturned,
      sort: sortKey
    }
  });
};

var hasPublishedCustomContent = function hasPublishedCustomContent() {
  var body = {};
  return customContentService.post('content-search', body, {
    params: {
      row: 0,
      num: 100
    }
  }).then(function (response) {
    var publishedLessons = response.results.filter(function (result) {
      return result.contentStatus !== 'CREATED';
    });
    return publishedLessons.length > 0;
  });
};

var hasCustomContent = function hasCustomContent() {
  var body = {};
  return customContentService.post('content-search', body, {
    params: {
      row: 0,
      num: 100
    }
  }).then(function (response) {
    var publishedLessons = response.results;
    return publishedLessons.length > 0;
  });
};

var getDownloadUrl = function getDownloadUrl(key) {
  return customContentService.get("content/".concat(key, "/download-url"));
};

var getUploadUrl = function getUploadUrl(key, assets, needsAssetManagement) {
  var params = {};

  if (needsAssetManagement !== undefined) {
    params['assets-management'] = needsAssetManagement;
  }

  return customContentService.post("content/".concat(key, "/upload-url"), assets, {
    params: params
  });
};

var markContentStatus = function markContentStatus(key, status, skipReview) {
  if (!Object.values(CUSTOM_CONTENT_STATUSES).includes(status)) {
    console.error('incorrect custom content status provided', status);
    return Promise.reject();
  }

  var params = {};

  if (skipReview !== undefined) {
    if (status !== CUSTOM_CONTENT_STATUSES.UPLOAD_COMPLETE) {
      console.warn('Ignoring skipReview; this is only available when marking the content status as upload-complete');
    } else {
      params.skipReview = skipReview;
    }
  }

  return customContentService.put("content/".concat(key, "/mark/").concat(status), undefined, {
    params: params
  });
};

var setCustomContentFacetValue = function setCustomContentFacetValue(key, facetType, value) {
  if (!Object.values(CUSTOM_CONTENT_FACETS).includes(facetType)) {
    throw new Error('Invalid facet type', facetType);
  }

  var headers = {
    'Content-Type': 'text/plain'
  };
  return customContentService.post("content/".concat(key, "/").concat(facetType), value, {
    headers: headers
  });
};

var removeCustomContentFacetValue = function removeCustomContentFacetValue(key, facetType, value) {
  if (!Object.values(CUSTOM_CONTENT_FACETS).includes(facetType)) {
    throw new Error('Invalid facet type', facetType);
  }

  return customContentService["delete"]("content/".concat(key, "/").concat(facetType, "/").concat(encodeURIComponent(value)));
};

var _default = {
  createCustomContent: createCustomContent,
  fetchCustomContent: fetchCustomContent,
  fetchCustomContentByAdvancedSearch: fetchCustomContentByAdvancedSearch,
  fetchCustomContentBySearch: fetchCustomContentBySearch,
  fetchCustomContentItemBySearch: fetchCustomContentItemBySearch,
  getCustomContentForLesson: getCustomContentForLesson,
  getDownloadUrl: getDownloadUrl,
  getUploadUrl: getUploadUrl,
  hasPublishedCustomContent: hasPublishedCustomContent,
  hasCustomContent: hasCustomContent,
  markContentStatus: markContentStatus,
  removeCustomContentFacetValue: removeCustomContentFacetValue,
  setCustomContentFacetValue: setCustomContentFacetValue,
  updateCustomContent: updateCustomContent,
  CUSTOM_CONTENT_FACETS: CUSTOM_CONTENT_FACETS,
  CUSTOM_CONTENT_STATUSES: CUSTOM_CONTENT_STATUSES
};
exports["default"] = _default;